import styled, { createGlobalStyle } from 'styled-components';

export const StyledAccountSelectContainer = styled('div')`
  .account-select-container {
    margin-bottom: 0;
    
    .account-select-freesolo {
      .ant-select-selector {
        font-size: ${({ theme }) => theme.token.fontSizeHeading3}px;
      }

      .ant-select-selection-search input {
        font-size: ${({ theme }) => theme.token.fontSizeHeading3}px !important;
      }
    }
  }
}
`;

export const AccountSelectDropdownStyles = createGlobalStyle`
  .account-select-freesolo-dropdown {
    .ant-select-item,
    .ant-select-item-option {
      padding: ${({ theme }) => theme.token.paddingXXS}px ${({ theme }) => theme.token.paddingSM}px;
    }

    .ant-select-item-group {
      padding: ${({ theme }) => theme.token.paddingXXS}px ${({ theme }) => theme.token.paddingSM}px;
      font-size: ${({ theme }) => theme.token.fontSize}px;
    }
  }
`;
